export default "__VITE_ASSET__B3NVdoPR__"